import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { APP_ROUTES } from '_app/routes';
import logo from 'assets/pyk_logo.svg';

const Logo = props => {
  return (
    <Link to={APP_ROUTES.HOME}>
      <Box as="img" w="100%" maxW="140px" src={logo} alt="logo" {...props} />
    </Link>
  );
};

export default Logo;
